<template>
  <div class="content main-container">
    <div class="search-box min">
      <div class="input-item">
        <span class="label">代理人</span>
        <Select v-model="searchParams.owerId" clearable filterable>
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        />
      </div>
      <div class="btn-item">
        <Button type="primary" class="ico-btn" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="handleReset">重置</Button>
      </div>
    </div>
    <Tabs v-model="searchParams.checkStatus" :animated="false" @on-click="handleToggleTab">
      <TabPane v-for="tab in tabsList" :key="tab.value" :label="getNumText(tab.label, tab.value)" :name="tab.value"></TabPane>
    </Tabs>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="checkStatus">
          <Tag v-if="row.checkStatus == 1" color="orange">待确认</Tag>
          <Tag v-if="row.checkStatus == 2" color="primary">已确认待打款</Tag>
          <Tag v-if="row.checkStatus == 3" color="green">打款成功</Tag>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span @click="handleViewItem(row)" class="table-btn">明细</span>
          <span v-if="row.checkStatus == 1" style="color: #e3461f" class="table-btn" @click="revokeCheck(row)">撤销对账</span>
          <span class="table-btn" @click="exportCheck(row)">导出对账单</span>
          <span v-if="[2, '2'].includes(row.checkStatus)" style="color: #19be6b" class="table-btn" @click="showChangeStatus(row)">已打款</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
    <Modal v-model="showStatus" title="打款" width="400" :footer-hide="true">
      <Form ref="form" :model="formData" class="page-form8" :label-width="100">
        <FormItem label="打款时间:" prop="payDate" :rules="$units.formRule.objRequired('请选择打款时间')">
          <DatePicker
            type="date"
            @on-change="formData.payDate = $event"
            format="yyyy-MM-dd"
            :transfer="true"
            placement="bottom"
            :value="formData.payDate"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="showStatus = false">取消</Button>
        <Button type="primary" @click="changeMerchantWithdrawLog">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { filterTime } from '@/api/filter';
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  components: {},
  data() {
    return {
      columns: [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            const value = params.row.settlementDate ? params.row.settlementDate.substr(0, 10) : '';
            return <div>{value}</div>;
          }
        },
        {
          title: '姓名',
          align: 'center',
          key: 'owerName',
          minWidth: 120
        },
        {
          title: '对账状态',
          align: 'center',
          slot: 'checkStatus',
          minWidth: 120
        },
        {
          title: '入职时间',
          align: 'center',
          key: 'entryTime',
          minWidth: 120,
          render(h, params) {
            let entryTime = params.row.entryTime;
            return <span>{filterTime(entryTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '是否active状态',
          align: 'center',
          key: 'activeStatus',
          minWidth: 140,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true}>
                <span>是否active状态</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>上一季度是否为active状态</p>
                </div>
              </Poptip>
            );
          },
          render(h, params) {
            let activeStatus = params.row.activeStatus;
            return <span>{activeStatus == 1 ? '是' : '否'}</span>;
          }
        },
        {
          title: '件数',
          align: 'center',
          key: 'policyNum',
          minWidth: 120
        },
        {
          title: '保费合计(美元)',
          align: 'center',
          key: 'feeSum',
          minWidth: 120
        },
        {
          title: '佣金合计(港币)',
          align: 'center',
          key: 'totalCommission',
          minWidth: 120
        },
        {
          title: '销售佣金',
          align: 'center',
          key: 'salesCommission',
          minWidth: 120
        },
        {
          title: '推荐奖',
          align: 'center',
          key: 'recommendBonus',
          minWidth: 120
        },
        {
          title: '辅导奖',
          align: 'center',
          key: 'tutorBonus',
          minWidth: 120
        },
        {
          title: '管理津贴',
          align: 'center',
          key: 'teamBonus',
          minWidth: 120
        },
        {
          title: '育成奖',
          align: 'center',
          key: 'trainBonus',
          minWidth: 120
        },
        {
          title: '年度个人Bonus',
          align: 'center',
          key: 'personalBonus',
          minWidth: 130
        },
        {
          title: '周边收支',
          align: 'center',
          key: 'surrounds',
          minWidth: 120
        },
        {
          title: '佣金调整',
          align: 'center',
          key: 'adjustments',
          minWidth: 120
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          fixed: 'right',
          minWidth: 230
        }
      ],
      userList: [],
      userInfo: {},
      changeId: '',
      formData: {
        payDate: ''
      },
      showStatus: false,
      searchParams: {
        checkStatus: '1',
        settlementDate: ''
      },
      tabsList: [
        {
          label: '待确认',
          value: '1'
        },
        {
          label: '已确认待打款',
          value: '2'
        },
        {
          label: '打款成功',
          value: '3'
        }
      ]
    };
  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.initListParams('/buz/ifaSettlementReport/queryCheckPage');
    this.getUserList();
  },
  activated() {
    this.getList();
  },
  methods: {
    exportCheck(row) {
      this.$units.downloadFile('/buz/ifaSettlementReport/exportCheck', { id: row.id }, 'GET');
    },
    // 撤销对账
    revokeCheck(row) {
      this.$notice.inquiry('请确认是否撤销对账？').then(() => {
        this.$http({
          url: '/buz/ifaSettlementReport/revokeCheck',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(() => {
          this.$notice.success('操作成功');
          this.getList();
        });
      });
    },
    changeMerchantWithdrawLog() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        let params = {
          payDate: this.formData.payDate,
          id: this.changeId
        };
        this.$http({
          url: '/buz/ifaSettlementReport/payment',
          type: 'POST',
          data: params
        }).then(() => {
          this.$notice.success('操作成功');
          this.showStatus = false;
          this.changeId = '';
          this.formData.paymentTime = '';
          this.getList();
        });
      });
    },
    //打款
    showChangeStatus(row) {
      this.showStatus = true;
      this.changeId = row.id;
      this.formData.payDate = '';
    },
    // 查询申请人
    getUserList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: {
          selectSub: 1
        }
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    },
    getNumText(label, value) {
      return label;
    },
    handleToggleTab(tabName) {
      this.searchAjax();
    },
    reload() {
      this.getList();
    },
    handleReset() {
      this.pageNum = 1;
      this.searchParams.tenantId = '';
      this.searchParams.settlementDate = '';
      this.getList();
    },
    handleViewItem(row) {
      this.$router.push({
        path: '/basicLaw/checkAccounts/settlementDetail',
        query: {
          backUrl: this.$route.fullPath,
          id: row.id,
          settleId: row.settleId,
          owerId: row.owerId,
          totalCommission: row.totalCommission
        }
      });
    },
    // 设置参数
    setListParams(params) {
      // 结算日期
      this.$units.formatDateRange(params, 'settlementDate', ['settlementDateStart', 'settlementDateEnd'], true);
      delete params.settlementDate;
    },
    // 重置查询
    resetSearch() {
      this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
      this.searchAjax();
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  color: #6e574a;
  line-height: 1.6;
  border-radius: 4px;
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  font-size: 13px;
  .p2 {
    padding-left: 3em;
  }
  .blod {
    font-weight: bold;
  }
}
.content {
  .top {
    padding-bottom: 15px;
  }
}
/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
</style>
